export default 'M18 24h6v-6h-6zM6 24h6v-6H6zm6-6h6v-6h-6zM0 18h6v-6H0zm18-6h6V6h-6zM6 12h6V6H6zm6-6h6V0h-6zM0 6h6V0H0z';